import { render, staticRenderFns } from "./reviewsView.vue?vue&type=template&id=66d96dae&"
import script from "./reviewsView.vue?vue&type=script&lang=js&"
export * from "./reviewsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports